import { useCallback, useEffect, useState, useRef } from 'react';

import browser from '@openclassrooms/ui-web/browser';
import { getActiveLang, getActiveCountry } from '@openclassrooms/translations';
import { getGoogleConfig } from '@openclassrooms/common-app/social/services';
import { load } from 'Services/lazyScript';

import type { SocialLoginButtonProps } from './types';

const GoogleLoginButton = ({ onSuccess = () => {} }: SocialLoginButtonProps) => {
  const config = getGoogleConfig();
  const elementRef = useRef(null);
  const [isGoogleIdentityLoaded, setIsGoogleIdentityLoaded] = useState(browser.window.google);

  const handleCredentialResponse = useCallback(
    (response) => {
      onSuccess({ accessToken: response?.credential });
    },
    [onSuccess]
  );

  useEffect(() => {
    const loadGoogleIdentify = () => {
      load('https://accounts.google.com/gsi/client').then(() => {
        browser.window.google.accounts.id.initialize({
          client_id: config.clientId,
          callback: handleCredentialResponse,
        });

        setIsGoogleIdentityLoaded(true);
      });
    };

    if (!isGoogleIdentityLoaded) {
      loadGoogleIdentify();
    }
  }, [config.clientId, handleCredentialResponse, isGoogleIdentityLoaded]);

  useEffect(() => {
    const renderGoogleButton = () => {
      const { google } = browser.window;
      const googleButtonLocale = `${getActiveLang()}_${getActiveCountry()}`;

      google.accounts.id.renderButton(elementRef.current, {
        type: 'icon',
        locale: googleButtonLocale,
      });
    };

    if (isGoogleIdentityLoaded) {
      renderGoogleButton();
    }
  }, [isGoogleIdentityLoaded]);

  return <div ref={elementRef} style={{ minWidth: '40px' }} />;
};

export default GoogleLoginButton;
